// src/components/Services.jsx

import React from 'react';

const CompetitiveAdvantage = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold text-black mb-5">
  Company<span className="text-[#680099] ml-2 font-bold">Advantage</span>
</h2>

      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}>Competitive Edge</div>
          <p style={boxContentStyle}> Proven Market Demand</p>
          <p style={boxContentStyle}> Exclusive Partnerships</p>
          <p style={boxContentStyle}> Unique Forex Integration</p>
          <p style={boxContentStyle}> Real-Time Customization Capability </p>

        </div>

        {/* Right box */}
        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Explanation</div>
          <p style={boxContentStyle}> ₹ 1 Crore in Organic Revenue, Highlighting Market Alignment And Demand</p>
          <p style={boxContentStyle}> Establishing Exclusive Partnerships Offer Preferred Rates, 10 Sub-Agents(B2B) Enhance Network Reach</p>
          <p style={boxContentStyle}> Pending Forex License Positions Vigovia To Offer A Combined Travel And Currency Exchange Service</p>
          <p style={boxContentStyle}> In-House Platform With Strategic Partners API For Live Pricing And Itinerary Customization</p>

        </div>
      </div>

      
    </div>
  );
};

const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '30%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px'
};

const bulletPointsStyle = {
  listStyleType: 'disc',  // Bullet points (disc)
  paddingLeft: '20px',    // Indentation for the list
  marginTop: '19px',      // Space above the list
};

const bulletPointItemStyle = {
  fontSize: '18px',       // Font size for the bullet point text
  marginBottom: '10px',   // Space between each bullet point
  lineHeight: '1.6',      // Line height for readability
};

export default CompetitiveAdvantage;
